import {
  Box,
  FormControl,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  Checkbox,
  ListItemText,
  Button,
  TableContainer,
  Paper,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Chip,
  Table,
  DialogContent,
} from "@material-ui/core";

import moment from "moment";
import { Clear, Refresh } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import { Autocomplete } from "@material-ui/lab";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// Importing dialogue box
import StyledDialog from "../viewComponentAllocation/MessageDialogBox";
// Material Ui Dialog wrapper
import Dialog from "@material-ui/core/Dialog";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import PaginationInput from "../../common/models/pagination/PaginationInput";
import StyledButton from "../../common/models/Button";
import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import BackDropLoading from "../../common/models/BackDrop";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../containers/actions/types";

const useStyles = makeStyles((theme) => ({
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #000000de",
    borderRadius: "0.5rem",
    padding: "0.3rem",
    width: "20px",
    height: "20px",
    textTransform: "none",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "black",
      color: "white",
      border: "1px solid #000000de",
    },
  },
  logoHeight: {
    height: "inherit",
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "2.8rem",
    paddingRight: "2.8rem",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  clearText: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: "#173072",
      textDecoration: "underline",
    },
  },
  dpFlx: { display: "flex" },
  algnCntr: { alignItems: "center" },
  pointer: { cursor: "pointer" },
  onHvrUndrline: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  BtnSty: {
    backgroundColor: "transparent",
    color: "black",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      border: "1px solid black",
    },
  },
  inputBaseRoot: {
    padding: "0px",
    paddingRight: "14px",
    height: "40px",
  },
  backContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    marginBottom: "18px",
    fontWeight: 500,
  },
  customChip: {
    background: "white",
    color: "black",
    borderRadius: "14px",
    border: "1px solid black",
    "& .MuiChip-label": {
      paddingLeft: "3px",
      paddingRight: "3px",
    },
  },
}));

export default function ViewComponentAllocation() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchSelectValue, setSearchSelectValue] = useState(null);
  const [selectedPlantIdList, setSelectedPlantIdList] = useState([]);
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [plantIdOptions, setPlantIdOptions] = useState([]);
  const [plantList, setPlantList] = useState(plantIdOptions);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [plantTypes, setPlantTypes] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allocationStatus, setAllocationStatus] = useState("All");
  const [materialAvailable, setMaterialAvailable] = useState("All");
  const [daysToDeliveryDate, setDaysToDeliveryDate] = useState("All");
  const [searchField, setSearchField] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [SelectedCMOList, setSelectedCMOList] = useState([]);
  // const [checkFlag, setCheckFlag] = useState(false);
  const [materialErrorData, setMaterialErrorData] = useState([]);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [openErrorRMPMDialog, setOpenErrorRMPMDialog] = useState(false)
  const [titleLine, setTitleLine] = useState({});
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page
  const [totalPages, setTotalPages] = useState(1);
  const [openRows, setOpenRows] = useState({});
  const [componentAllocationTableData, setComponentAllocationTableData] =
    useState([]);

  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  useEffect(() => {
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setSupplyTypes(
            res.data?.data?.supplyTypeList ? res.data?.data?.supplyTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setDrugTypes(
            res.data?.data?.drugTypeList ? res.data?.data?.drugTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantTypes`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          setPlantTypes(
            res.data?.data?.plantTypeList ? res.data?.data?.plantTypeList : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllVendorPlants`
      )
      .then((res) => {
        if (res.data?.status) {
          setPlantList(
            res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
          );
          setPlantIdOptions(
            res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : []
          );
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  function handleClearSearch() {
    setSearchField("all");
    setSearchValue("");
    // setLoading(true);
    setSearchSelectValue(null);
    setRefreshSearch(!refreshSearch);
  }

  const handleChangeCMOList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedCMOList(
        SelectedCMOList.length === cmoMemberWithId.length
          ? []
          : cmoMemberWithId.map((val) => val.organization_id)
      );
      setPlantList(
        plantIdOptions.filter((val) =>
          cmoMemberWithId
            .map((val) => val.organization_id)
            .includes(val.vendorMosymphonyID)
        )
      );
    } else {
      setSelectedCMOList(value);
      setPlantList(
        plantIdOptions.filter((val) => value.includes(val.vendorMosymphonyID))
      );
    }
  };

  const getDisplayCMOFilterValue = () => {
    if (SelectedCMOList.length === cmoMemberWithId.length) return "All";
    return "Multiple selection";
  };

  const handleChangePlantIdList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedPlantIdList(
        selectedPlantIdList.length === plantList.length
          ? []
          : plantList.map((val) => val.plantCode)
      );
    } else {
      setSelectedPlantIdList(value);
    }
  };

  const getDisplayPlantIDValue = () => {
    if (selectedPlantIdList.length === plantList.length) return "All";
    return "Multiple selection";
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleRowToggle = (id) => {
    setOpenRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const history = useHistory();

  // Handler to open the detail view for component allocation
  const handleOpenDetailViewAllocation = (row) => {
    //console.log("row :", row);
    const selectedRowData = row;
    if (row?.showCheckMaterialsButton) {
      const id = row.schrockenSLID;
      history.push(
        `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/viewDetailedComponentAllocation?SLID=${id}`,
        { selectedRowData }
      );
      // setOpenDetailedView(true);
    } else {
      history.push(
        `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/viewBatchComponentAllocation`,
        { selectedRowData }
      );
      // setBatchView(true);
    }
  };

  function handleClearFilters() {
    setAllocationStatus("All");
    setMaterialAvailable("All");
    setDaysToDeliveryDate("All");
    setSelectedCMOList([]);
    setCurrentPage(1);
    setSelectedPlantIdList([]);
    setSearchSelectValue(null);
  }

  const handleRefresh = () => {
    setRefreshPage(!refreshPage);
    setError(null);
  };

  function handleSearchClick() {
    setRefreshSearch(!refreshSearch);
    setCurrentPage(1);
    setError(null);
  }

  const handleSearchField = (event) => {
    setSearchField(event.target.value);
    setSearchValue("");
    setSearchSelectValue(null);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
  };
  const handlePageChange = (val) => {
    setCurrentPage(val);
  };

  function handleSearchValue(e) {
    setSearchValue(e.target.value);
  }

  function handleAPICall() {
    setOpenRows({})
    setLoading(true);
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllPOLinesComponentAllocation`;
    axios
      .post(url, {
        searchField: searchField,
        searchValue: searchValue,
        daysToDeliveryDate: daysToDeliveryDate,
        brandOwnerMosymphonyID: "",
        // vendorMosymphonyIDList: [],
        vendorMosymphonyIDList: SelectedCMOList,
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        // plantCodeList: [],
        plantCodeList: selectedPlantIdList,
        materialsAvailable: materialAvailable,
        allocationStatus: allocationStatus,
      })
      .then((res) => {
        // throw new Error("API response status is false");
        if (res.data.status) {
          ///console.log("API data", res?.data?.data?.POLineAllocationDetailsList);
          setComponentAllocationTableData(
            res?.data?.data?.POLineAllocationDetailsList
          );
          setTotalPages(res.data.data.numberOfPages);
          // setComponentAllocationTableData([]);
          setError(null);
        }
      })
      .catch((err) => {
        setError(true);
        console.error("Error=> ", err.message);
      })
      .finally(() => setLoading(false));
  } 

  const handleAPICallMemoized = useCallback(handleAPICall, [
    SelectedCMOList,
    selectedPlantIdList,
    refreshSearch,
    refreshPage,
    materialAvailable,
    daysToDeliveryDate,
    allocationStatus,
    rowsPerPage,
    currentPage,
  ]);
  // API to fetch data for dashboard
  useEffect(() => {
    handleAPICallMemoized()
  }, [
    handleAPICallMemoized
  ]);

  const handleDialogOpen = (data) => {
    //console.log("data check material:", data);
    if (data?.materialsAvailable === null) { 
      setOpenErrorRMPMDialog(true);
    } else if (!data?.materialsAvailable) {
      setMaterialErrorData(data?.deficitComponentsList);
      // setCheckFlag(false);
      setOpenErrorDialog(true);
    } else if (data?.materialsAvailable) {
      setMaterialErrorData([]);
      // setCheckFlag(true);
      setOpenSuccessDialog(true);
    }
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    handleAPICall();
  };

  const handleErrorDialogClose = () => {
    setOpenErrorDialog(false);
    handleAPICall();
  };

  const handleErrorRMPMDialogClose = () => {
    setOpenErrorRMPMDialog(false);
    handleAPICall();
  };
  
  //Check materials handler
  const handleCheckMaterial = (data) => {
    setTitleLine(data);
    let checkMaterialReqObj = {
      schrockenSLID: data.schrockenSLID,
      cdmoOrgID: data?.vendorMosymphonyID,
    };
    dispatch({
      type: OPEN_BACKDROP,
    });
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/checkMaterialAvailability`;
    axios
      .post(url, checkMaterialReqObj)
      .then((response) => {
        if (response?.data) {
          handleDialogOpen(response?.data?.data);
        }
        dispatch({
          type: DESTROY_BACKDROP,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        dispatch({
          type: DESTROY_BACKDROP,
        });
      });
  };

  const displayLoading = (
    <TableRow>
      <TableCell colSpan={10} align="center">
        <CircularProgress color="primary" thickness={7} />
      </TableCell>
    </TableRow>
  );

  const tableError = (
    <TableRow
      style={{
        border: "2px solid #FF0000",
        backgroundColor: "#FFF0F0",
        marginTop: "10px",
      }}
    >
      <TableCell colSpan={10} align="center">
        Something went wrong. Please try again later.
      </TableCell>
    </TableRow>
  );

  const noRecordsFoundMsgDisplay = (
    <TableRow>
      <TableCell colSpan={10} align="center">
        No records found
      </TableCell>
    </TableRow>
  );

  // Save Filter function
  const handleSaveFilter = () => {
    // dispatch({
    //   type: OPEN_BACKDROP,
    //   backdropText: "Please Wait...",
    // });
    // let data = {
    //   ...savedFilter,
    //   cmoListFilter: SelectedCMOList,
    //   plantListFilter: selectedPlantIdList,
    //   plannerUserId: selectedPlannerList,
    // };
    // axios
    //   .post(`${appUrl}/user/saveDashboardFilters`, data)
    //   .then((res) => {
    //     // throw new Error("Mock Error");
    //     dispatch({
    //       type: DESTROY_BACKDROP,
    //     });
    //     if (res.data.status) {
    //       // dispatch(fetchPurchaseOrdersFilters());
    //       setSavedSuccessfull(true);
    //     } else {
    //       dispatch({
    //         type: DESTROY_BACKDROP,
    //       });
    //       setSaveFailed(true);
    //     }
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     dispatch({
    //       type: DESTROY_BACKDROP,
    //     });
    //     setSaveFailed(true);
    //   });
  };

  const handleCloseSave = () => {
    setSavedSuccessfull(false);
  };
  return (
    <>
      <BackDropLoading />
      <Grid container>
        {/* Back Button */}
        <div className={classes.backContainer} onClick={handleBack}>
          <ArrowBackIosIcon aria-label="Go back" />
          <Typography style={{ marginLeft: "8px", fontWeight:'500' }}>Back</Typography>
        </div>
      </Grid>
      {/* Search by DropDown and Search */}
      <Grid container>
        <Grid item>
          <Box
            style={{
              width: "30rem",
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
              marginRight: "20px",
            }}
          >
            <TextField
              size="small"
              select
              value={searchField}
              variant="outlined"
              onChange={handleSearchField}
              onKeyDown={(e) => e.key === "Enter" && handleSearchField()}
              style={{
                minWidth: 30,
                border: "1px solid black",
                borderRight: "none",
                borderRadius: "0.1rem",
                backgroundColor: "#F0F0F0",
              }}
            >
              <MenuItem value="all">Select search by</MenuItem>
              <MenuItem value="PO number">PO - line</MenuItem>
              <MenuItem value="Product code">Product code</MenuItem>
              <MenuItem value="Product description">
                Product description
              </MenuItem>
              <MenuItem value="Supply type">Supply type</MenuItem>
              <MenuItem value="Drug type">Drug type</MenuItem>
              <MenuItem value="Plant type">Plant type</MenuItem>
            </TextField>

            {!["Supply type", "Drug type", "Plant type"].includes(
              searchField
            ) && (
              <TextField
                size="small"
                value={searchValue}
                disabled={searchField === "all"}
                onChange={(e) => {
                  if (searchField !== "all") {
                    handleSearchValue(e);
                  }
                }} // Update search value on input
                onBlur={(e) => {
                      const { name, value } = e.target;
                      // Trim leading and trailing spaces for string values
                      if (searchField !== "all" && typeof value === "string" && value.trim() !== value) {
                        handleSearchValue({ target: { name, value: value.trim() } });
                      }
                    }}
                    onKeyDown={(e) => {
                          const { name, value } = e.target;
                          if(e.key === "Enter"){
                            handleSearchValue({ target:{ name, value: value.trim() } });
                            handleSearchClick()
                          }
                        }}// Call API on Enter key
                variant="outlined"
                placeholder="Search"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchValue && (
                        <Tooltip title="Clear search" aria-label="clear">
                          <Clear
                            fontSize="small"
                            onClick={handleClearSearch} // Clear search value
                            style={{
                              cursor: "pointer",
                              color: "dimgray",
                            }}
                          />
                        </Tooltip>
                      )}
                      <IconButton
                        size="small"
                        style={{
                          backgroundColor: "#EB5E28",
                          color: "white",
                          borderRadius: "0",
                          padding: "8px",
                          translate: "0.84rem",
                        }}
                        onClick={handleSearchClick}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                style={{
                  width: "100%",
                  flex: 1,
                  border: "1px solid black",
                  borderRadius: "0.1rem",
                }}
              />
            )}

            {["Supply type", "Drug type", "Plant type"].includes(
              searchField
            ) && (
              <Autocomplete
                options={
                  searchField === "Supply type"
                    ? supplyTypes
                    : searchField === "Drug type"
                    ? drugTypes
                    : searchField === "Plant type"
                    ? plantTypes
                    : []
                }
                getOptionLabel={(option) => {
                  if (searchField === "Supply type") {
                    return option.supplyType;
                  } else if (searchField === "Drug type") {
                    return option.drugType;
                  } else {
                    return option.plantType;
                  }
                }}
                value={searchSelectValue || null}
                onChange={(e, value) => {
                  if (searchField !== "all") {
                    setSearchSelectValue(value);
                    if (typeof value === "object") {
                      setSearchValue(
                        searchField === "Supply type"
                          ? String(value.supplyTypeID)
                          : searchField === "Drug type"
                          ? String(value.drugTypeID)
                          : searchField === "Plant type"
                          ? String(value.plantTypeID)
                          : null
                      );
                    } else {
                      setSearchValue("");
                    }
                  }
                }}
                style={{
                  width: "100%",
                  flex: 1,
                  border: "1px solid black",
                  borderRadius: "0.1rem",
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={searchValue}
                    variant="outlined"
                    placeholder="Search"
                    onChange={(e) => {
                      if (searchField !== "all") {
                        handleSearchValue(e);
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      className: classes.inputBaseRoot,
                      endAdornment: (
                        <InputAdornment position="end">
                          {searchValue && (
                            <Tooltip title="Clear search" aria-label="clear">
                              <Clear
                                fontSize="small"
                                onClick={handleClearSearch} // Clear search value
                                style={{
                                  cursor: "pointer",
                                  color: "dimgray",
                                }}
                              />
                            </Tooltip>
                          )}
                          <IconButton
                            size="small"
                            style={{
                              backgroundColor: "#EB5E28",
                              color: "white",
                              borderRadius: "0",
                              padding: "8px",
                              translate: "0.84rem",
                            }}
                            onClick={handleSearchClick}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            )}
          </Box>
        </Grid>
        <Grid item>
          <Typography style={{ fontWeight: 500, marginRight: "0.5rem" }}>
            Days to <br /> delivery date:
          </Typography>
        </Grid>
        {/* 5. Days to Delivery Dropdown */}
        <Grid item>
          <TextField
            size="small"
            select
            value={daysToDeliveryDate}
            onChange={(e) => {
              setDaysToDeliveryDate(e.target.value);
            }}
            variant="outlined"
            required
            className={classes.textField}
            SelectProps={{
              displayEmpty: true,
            }}
            style={{ width: "11rem" }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Less than 30">Less than 30</MenuItem>
            <MenuItem value="30 to 60">30 to 60</MenuItem>
            <MenuItem value="61 to 90">61 to 90</MenuItem>
            <MenuItem value="More than 90">More than 90</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      {/* Dropdowns */}
      <Grid
        container
        spacing={2}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          flexWrap: "nowrap",
        }}
      >
        <Grid
          item
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "end",
            flexDirection: "row",
          }}
        >
          {/* 1. CDMO Dropdown */}
          {localStorage.collabType === "Pharma Co" ? (
            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "5px",
                flexDirection: "column",
                marginTop: "1.5rem",
              }}
            >
              <Typography style={{ fontWeight: 500 }}>CMO:</Typography>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "9rem", marginRight: "1rem" }}
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={SelectedCMOList.length > 0 ? SelectedCMOList : []}
                  onChange={handleChangeCMOList}
                  // onClose={() => handleSelectChangeListLosesFocus("cmo")}
                  renderValue={(selected) =>
                    selected.length === 0
                      ? "All"
                      : getDisplayCMOFilterValue()
                  }
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={
                        SelectedCMOList?.length === cmoMemberWithId?.length
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {cmoMemberWithId?.map((option) => {
                    return (
                      <MenuItem key={option} value={option.organization_id}>
                        <Checkbox
                          checked={
                            SelectedCMOList?.indexOf(option.organization_id) >
                            -1
                          }
                        />
                        <ListItemText primary={option.organization_name} />
                      </MenuItem>
                    );
                  })}
                  {/* {cmoMemberWithId?.map((option) => (
                    <MenuItem key={option} value={option.organization_id}>
                      <Checkbox
                        checked={
                          SelectedCMOList.indexOf(option.organization_id) > -1
                        }
                      />
                      <ListItemText primary={option.organization_name} />
                    </MenuItem>
                  ))} */}
                </Select>
              </FormControl>
            </Grid>
          ) : (
            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "5px",
                flexDirection: "column",
                marginTop: "1.5rem",
              }}
            >
              <Typography style={{ fontWeight: 500 }}>Sponsor name:</Typography>
              <TextField
                variant="outlined"
                size="small"
                value={
                  componentAllocationTableData.length > 0
                    ? componentAllocationTableData[0]?.sponsorName
                    : ""
                }
                // disabled
                style={{ width: "11rem", marginRight: "1rem" }}
                InputProps={{
                  style: {
                    height: "36px",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                  },
                }}
              />
            </Grid>
          )}
          {/* 2. Plant Id Dropdown */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "5px",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Typography style={{ fontWeight: 500 }}>Plant ID:</Typography>
            <FormControl
              variant="outlined"
              size="small"
              style={{ width: "9rem", marginRight: "1rem" }} // Reduced width
            >
              <Select
                multiple
                fullWidth
                size="small"
                variant="outlined"
                displayEmpty
                value={
                  selectedPlantIdList.length > 0 ? selectedPlantIdList : []
                }
                onChange={handleChangePlantIdList}
                // onClose={() => handleSelectChangeListLosesFocus("plantID")}
                renderValue={(selected) =>
                  selected.length === 0
                    ? "All"
                    : getDisplayPlantIDValue()
                }
              >
                <MenuItem value="All">
                  <Checkbox
                    checked={selectedPlantIdList?.length === plantList?.length}
                  />
                  <ListItemText primary="All" />
                </MenuItem>
                {plantList?.map((option) => (
                  <MenuItem key={option} value={option?.plantCode}>
                    <Checkbox
                      checked={
                        selectedPlantIdList.indexOf(option?.plantCode) > -1
                      }
                    />
                    <ListItemText primary={option.plantCode} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* 3. Material Available Dropdown */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "5px",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Typography style={{ fontWeight: 500 }}>
              Material available:
            </Typography>
            <TextField
              size="small"
              select
              value={materialAvailable}
              onChange={(e) => {
                setMaterialAvailable(e.target.value);
              }}
              variant="outlined"
              required
              className={classes.textField}
              SelectProps={{
                displayEmpty: true,
              }}
              style={{ width: "9rem", marginRight: "1rem" }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="YES">Yes</MenuItem>
              <MenuItem value="NO">No</MenuItem>
            </TextField>
          </Grid>
          {/* 4. Allocation Status Dropdown */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "5px",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Typography style={{ fontWeight: 500 }}>
              Allocation status:
            </Typography>
            <TextField
              size="small"
              select
              value={allocationStatus}
              onChange={(e) => {
                setAllocationStatus(e.target.value);
              }}
              variant="outlined"
              required
              className={classes.textField}
              SelectProps={{
                displayEmpty: true,
              }}
              style={{ width: "9rem", marginRight: "1rem" }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Specified">Specified</MenuItem>
              <MenuItem value="Not specified">Not specified</MenuItem>
            </TextField>
          </Grid>
          {/* Clear filter */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "20px",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Typography
              variant="caption"
              style={{
                justifyContent: "end",
                fontSize: 12,
                color: "blue",
                marginLeft: "5px",
              }}
              className={classes.clearText}
              onClick={handleClearFilters}
            >
              Clear All Filters
            </Typography>
          </Grid>
        </Grid>
        {/* Last Sync */}
        <Grid item>
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Typography
                variant="body2"
                style={{ color: "gray", marginRight: "8px" }}
              >
                {`Last synced @ ${moment(new Date()).format(
                  "HH:mm:ss; DD MMMM, YYYY"
                )}`}
              </Typography>
              {/* Refresh Button */}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  textDecoration: "underline",
                  fontStyle: "italic",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={handleRefresh}
              >
                Refresh
                <Refresh color="primary" fontSize="small" />
              </Typography>
            </Grid>

            <Grid
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Typography
                style={{
                  fontWeight: 500,
                  marginRight: "4px",
                  whiteSpace: "nowrap",
                }}
              >
                PER PAGE
              </Typography>
              <FormControl variant="outlined" size="small">
                <Select value={rowsPerPage} onChange={handleRowsPerPageChange}>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Table */}
          <TableContainer style={{ marginTop: "2rem", minHeight:'auto',maxHeight:'400px'}} component={Paper}>
            <Table stickyHeader style={{ tableLayout: "auto", width: "100%" }}>
              <TableHead>
                <TableRow style={{ backgroundColor: "#F0F0F0" }}>
                  <TableCell
                    style={{ width: "30px",  }}
                  ></TableCell>
                  <TableCell style={{ width: "95px", whiteSpace:'nowrap', fontWeight:'600' }}>
                    PO - Line
                  </TableCell>
                  <TableCell style={{ width: "155px", whiteSpace:'nowrap', fontWeight:'600'  }}>
                    {localStorage.collabType === "Pharma Co"
                      ? "CMO"
                      : "Sponsor name"}
                  </TableCell>
                  <TableCell style={{ whiteSpace:'nowrap', fontWeight:'600' }}>Plant ID</TableCell>
                  <TableCell style={{ whiteSpace:'nowrap', fontWeight:'600' }}>
                    Product code / description
                  </TableCell>
                  <TableCell style={{ whiteSpace:'nowrap',textAlign: "right", fontWeight:'600' }}>
                    Days to delivery date
                  </TableCell>
                  <TableCell style={{ whiteSpace:'nowrap', fontWeight:'600'}}>
                    Material available
                  </TableCell>
                  <TableCell style={{  whiteSpace:'nowrap', textAlign: "center", fontWeight:'600' }}>
                    Allocation status
                  </TableCell>
                  <TableCell style={{ whiteSpace:'nowrap', fontWeight:'600' }}>Last updated</TableCell>
                  <TableCell style={{ whiteSpace:'nowrap', textAlign: "center", fontWeight:'600' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading
                  ? displayLoading
                  : error
                  ? tableError
                  : componentAllocationTableData.length === 0
                  ? noRecordsFoundMsgDisplay
                  : componentAllocationTableData?.map((row) => (
                      <React.Fragment key={row.poNumber}>
                        <TableRow>
                          <TableCell style={{  }}>
                            <IconButton
                              onClick={() => handleRowToggle(row.poNumber)}
                              size="small"
                            >
                              {openRows[row.poNumber] ? (
                                <ExpandMoreIcon />
                              ) : (
                                <ChevronRightIcon />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell style={{  }}>
                            {row?.poNumber}
                          </TableCell>
                          <TableCell style={{  }}>
                            {localStorage.collabType === "Pharma Co"
                              ? row.vendorName
                              : row.sponsorName}
                          </TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                          <TableCell style={{  }}></TableCell>
                        </TableRow>

                        {openRows[row.poNumber] &&
                          row?.detailList?.map((subRow) => (
                            <TableRow
                              key={subRow.poNumber}
                              style={{ backgroundColor: "#FAFAFA" }}
                            >
                              <TableCell style={{  }}></TableCell>
                              <TableCell style={{  }}>
                                {subRow.poNumber} - {subRow.poLineItemNumber}
                              </TableCell>
                              <TableCell style={{  }}>
                                {localStorage.collabType === "Pharma Co"
                                  ? subRow.vendorName
                                  : subRow.sponsorName}
                              </TableCell>
                              <TableCell style={{  }}>
                                {subRow.plantCode}
                              </TableCell>
                              <TableCell style={{  }}>
                                {subRow.productCode} / {subRow.productName}
                              </TableCell>
                              <TableCell style={{ textAlign: "right" }}>
                                {Math.abs(subRow.daysToDeliveryDate)}
                              </TableCell>
                              <TableCell style={{  }}>
                                {subRow.materialsAvailable}
                                <br />
                                <span style={{ fontSize: "10px" }}>
                                  {subRow?.latestSAPSyncDate
                                    ? `@` +
                                      " " +
                                      new Date(subRow?.latestSAPSyncDate+ "Z")
                                        .toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          second: "2-digit",
                                          hour12: false,
                                        })
                                        .replace(/([a-z]+)/i, (match) =>
                                          match.toUpperCase()
                                        )
                                    : ""}
                                </span>
                              </TableCell>
                              <TableCell style={{  }}>
                                {subRow?.allocationStatus === "Specified" ||
                                subRow?.allocationStatus === "Allocated" ? (
                                  <span
                                    style={{
                                      padding: "8px",
                                      backgroundColor: "green",
                                      color: "white",
                                      display: "block",
                                      width: "87%",
                                      textAlign: "center",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    Specified
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      padding: "8px",
                                      backgroundColor: "grey",
                                      color: "white",
                                      display: "block",
                                      width: "87%",
                                      textAlign: "center",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    Not Specified
                                  </span>
                                )}
                              </TableCell>
                              <TableCell style={{  }}>
                                {subRow.lastUpdatedDate
                                  ? new Date(subRow.lastUpdatedDate+ "Z")
                                      .toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                      })
                                      .replace(/([a-z]+)/i, (match) =>
                                        match.toUpperCase()
                                      )
                                  : "--"}
                              </TableCell>
                              <TableCell>
                                <div
                                  style={{
                                    // marginTop: "15px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px",
                                    // paddingBottom: "19px",
                                  }}
                                >
                                {subRow?.showCheckMaterialsButton ? 
                                <IconButton
                                style={{
                                  border: "1px solid black",
                                  borderRadius: "8px",
                                  padding: "2px",
                                }}
                              >
                                <VisibilityIcon
                                  onClick={() =>
                                    handleOpenDetailViewAllocation(subRow)
                                  }
                                />
                                  </IconButton>
                                    :
                                    (Array.isArray(subRow?.batchesList) && subRow?.batchesList.length > 0) 
                                  ? <IconButton
                                  style={{
                                    border: "1px solid black",
                                    borderRadius: "8px",
                                    padding: "2px",
                                  }}
                                >
                                  <VisibilityIcon
                                    onClick={() =>
                                      handleOpenDetailViewAllocation(subRow)
                                    }
                                  />
                                    </IconButton>
                                    : null
                              }
                                

                                {(localStorage.collabType !== "CMO" && subRow?.showCheckMaterialsButton) &&
                                <Chip
                                label="Check materials"
                                className={classes.customChip}
                                // style={{
                                //   visibility: subRow.showCheckMaterialsButton
                                //     ? "visible"
                                //     : "hidden",
                                // }}
                                onClick={() => handleCheckMaterial(subRow)}
                              />
                                }
                                </div>
                                
                              </TableCell>
                            </TableRow>
                          ))}
                      </React.Fragment>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>

        {/* Success Dialog Box for material available */}
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          maxWidth="sm"
          fullWidth
        >
          <StyledDialog
            title="RM/PM quantity available in stock"
            icon={false} // false for success (CheckCircle), true for error (CancelIcon)
            handleClose={handleSuccessDialogClose}
            isButtonDisabled={false} // If you want to disable the OK button
          />
        </Dialog>
        {/* Dialog box for error or Material not available */}
        <Dialog
          open={openErrorDialog}
          onClose={handleErrorDialogClose}
          maxWidth="sm"
          fullWidth
        >
          <StyledDialog
            title="RM/PM quantity not available in stock"
            subtitle={`Quantity of the following RM/PM materials from plant ${titleLine.plantCode} is not sufficient for production of ${titleLine.productName} - ${titleLine.productCode} product:`}
            icon={true} // false for success (CheckCircle), true for error (CancelIcon)
            handleClose={handleErrorDialogClose}
            isButtonDisabled={false} // If you want to disable the OK button
            tableData={materialErrorData}
          />
      </Dialog>
      
      <Dialog
          open={openErrorRMPMDialog}
          onClose={handleErrorRMPMDialogClose}
          maxWidth="sm"
          fullWidth
        >
          <StyledDialog
            title="PO component allocation not synced from SAP"
            icon={true} // false for success (CheckCircle), true for error (CancelIcon)
            handleClose={handleErrorRMPMDialogClose}
            isButtonDisabled={false} // If you want to disable the OK button
          />
        </Dialog>
      
        {/* Save filter dialogue boxes */}
        <Dialog open={savedSuccessfull} fullWidth>
          <StyledDialog
            icons={true}
            handleClose={handleCloseSave}
            title={"Saved successfully"}
          />
        </Dialog>
        <Dialog
          open={saveFailed}
          onClose={() => {
            setSaveFailed(false);
          }}
          fullWidth
        >
          <DialogContent style={{ padding: "2rem" }}>
            <Grid container justifyContent="flex-end">
              <Typography
                variant="body2"
                style={{
                  fontSize: "1rem",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSaveFailed(false);
                }}
              >
                Close <CloseIcon fontSize="large" />
              </Typography>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <WarningIcon
                  style={{
                    fontSize: "5rem",
                    color: "#F00",
                  }}
                />
              </Grid>
            </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "center", // Horizontally center the CircularProgress
                alignItems: "center", // Vertically center the CircularProgress
                height: "80px", // Optional: Set a height to vertically center the loader
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                // width: "100%",
              }}
            >
              <Typography style={{ textAlign: "center" }}>
                Something went wrong. Please try again.
              </Typography>
            </div>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                padding: "0.5rem",
              }}
            >
              <StyledButton
                style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
                onClick={() => {
                  setSaveFailed(false);
                }}
              >
                Ok
              </StyledButton>
            </Grid>
          </DialogContent>
        </Dialog>

      {/* Table Pagination */}
      {componentAllocationTableData?.length !== 0 ? (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: "1rem" }}
        >
          <PaginationInput
            totalPages={totalPages} //from api
            handlePageChange={handlePageChange}
            page={currentPage}
          />
        </Grid>
      ) : null}
    </>
  );
}
